module.exports = __webpack_public_path__ + "static/media/mainImg2.c330e82d.jpeg";